import { Colors } from '@oy/uicore';
import React from 'react';

type IconProps = {
  selected?: boolean;
  size?: number;
  color?: Colors;
  id?: string;
  isDisabled?: boolean;
};

const Icon: React.FC<IconProps> = ({
  id,
  selected = true,
  size = 20,
  color = Colors.BLUE100,
  isDisabled = false,
}: IconProps) => {
  return (
    <svg
      id={id}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
    >
      {selected ? (
        <g>
          <path
            d="M4,12a8,8 0 1,0 16,0a8,8 0 1,0 -16,0"
            fill={isDisabled ? Colors.BLACK40 : color}
          />
          <path
            d="M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,0 12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 Z M12,19.2 C8.0235498,19.2 4.8,15.9764502 4.8,12 C4.8,8.0235498 8.0235498,4.8 12,4.8 C15.9764502,4.8 19.2,8.0235498 19.2,12 C19.2,15.9764502 15.9764502,19.2 12,19.2 Z"
            fill={isDisabled ? Colors.BLACK10 : Colors.BLUE10}
          />
        </g>
      ) : (
        <circle
          cx="12"
          cy="12"
          r="10"
          fill={isDisabled ? Colors.BLACK10 : 'none'}
          stroke={isDisabled ? Colors.BLACK40 : Colors.BLACK100}
        />
      )}
    </svg>
  );
};

export default Icon;
